//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  SfTabs,
  SfButton,
  SfIcon
} from '@storefront-ui/vue';
import Paginate from '~/components/Paginate';
import { useApiError, useDistributor } from '@bee-hole/coms';
import DistributorList from '~/components/Order/DistributorList';
import { onSSR } from '@vue-storefront/core';
import { computed } from '@nuxtjs/composition-api';
import LazyHydrate from 'vue-lazy-hydration';
export default {
  name: 'DistributorDetails',
  components: {
    SfTabs,
    SfButton,
    SfIcon,
    Paginate,
    DistributorList,
    LazyHydrate
  },
  setup(props, context) {
    const {
      root: {
        $cookies
      }
    } = context;
    const { set: setError } = useApiError();
    let useDistributorClass;
    try {
      useDistributorClass = useDistributor();
    } catch (e) {
      // setError({ message: useDistributor, code: 50 });
      setError({ message: e.toString(), code: 50 });
    }
    const applyDistributor = async () => {
      if (useDistributorClass?.result.value?.list) {
        await useDistributorClass?.distributorList();
        return;
      }
      await useDistributorClass?.distributorAdd();
    };
    onSSR(async () => {
      await useDistributorClass?.distributorList();
      // await useDistributorClass?.distributorOrderList(QueryParams.value);
    });
    const copyUrl = () => {
      const el = document.createElement('textarea');
      el.value = window.location.origin + '/' + $cookies.get('vsf-locale') + '/?ref=' + useDistributorClass?.result?.value?.list?.[0].distributor_code;
      if (document.body) {
        document.body.appendChild(el);
      }
      el.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        setError({ code: 0, message: context.root.$t('Distributor_copy_success') });
      }
      document.body.removeChild(el);
    };
    return {
      applyDistributor,
      distributorInfo: useDistributorClass.result,
      distributorUrl: computed(() => {
        return useDistributorClass.result.value?.list ? useDistributorClass.result.value?.list[0].distributor_code : '';
      }),
      copyUrl
    };
    // return {};
  }
};
